import React from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';

class AuthenticatedRouteContainer extends React.Component {
  render() {
    const {
      isAuthenticated,
      component: Component,
      ...props,
    } = this.props;

    return (
      <Route
        {...props}
        render={props =>
          isAuthenticated
            && <Component {...props} />
        }
      />
    )
  }
}

export default connect(state => ({
  isAuthenticated: state.Auth.isAuthenticated,
}))(AuthenticatedRouteContainer);


// WEBPACK FOOTER //
// ./src/containers/AuthenticatedRoute/index.jsx